<div class="text-center">
  <h5 class="text-lg font-normal mb-0">{{'ADMIN.TRIAL.NO_TRIAL_HISTORY' | translate}}</h5>
</div>
